import { render, staticRenderFns } from "./contest-list.html?vue&type=template&id=c5fe43dc&scoped=true&"
import script from "./contest-list.js?vue&type=script&lang=js&"
export * from "./contest-list.js?vue&type=script&lang=js&"
import style0 from "./contest-list.scss?vue&type=style&index=0&id=c5fe43dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fe43dc",
  null
  
)

export default component.exports